import { DATACHANNEL_SCHEMAS } from './datachannel.js';
/**
 * Decode a raw data-channel payload (Uint8Array or string) for a known topic.
 * Enforces the envelope rules of §3.5: JSON parse, integer `v`, schema-valid.
 * Unknown `v` is rejected as 'bad-version' (never guessed); anything else failing
 * validation is 'bad-schema'. Callers count rejects and never partially interpret.
 */
export function decodeTopic(topic, raw) {
    let text;
    if (typeof raw === 'string') {
        text = raw;
    }
    else {
        text = new TextDecoder('utf-8', { fatal: false }).decode(raw);
    }
    let parsed;
    try {
        parsed = JSON.parse(text);
    }
    catch {
        return { ok: false, reason: 'bad-json' };
    }
    // Reject unknown schema version explicitly (§3.5) before full validation.
    if (typeof parsed === 'object' &&
        parsed !== null &&
        'v' in parsed &&
        parsed.v !== 1) {
        return { ok: false, reason: 'bad-version' };
    }
    const schema = DATACHANNEL_SCHEMAS[topic];
    const result = schema.safeParse(parsed);
    if (!result.success) {
        return { ok: false, reason: 'bad-schema', error: result.error.message };
    }
    return { ok: true, value: result.data };
}
/** Encode a validated message to a UTF-8 JSON Uint8Array for publishData. */
export function encodeJson(message) {
    return new TextEncoder().encode(JSON.stringify(message));
}
//# sourceMappingURL=decode.js.map